import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Cube, Spinner, CheckCircle } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#FAFAFB]">
      <div className="w-full max-w-sm">
        <Link to="/" className="flex items-center gap-2 mb-8">
          <div className="h-8 w-8 rounded-md bg-emerald-500 flex items-center justify-center"><Cube size={18} weight="bold" className="text-white" /></div>
          <span className="font-display font-bold text-lg">Orbit Inventory Management</span>
        </Link>
        {done ? (
          <div className="text-center" data-testid="forgot-success">
            <CheckCircle size={48} weight="fill" className="text-emerald-500 mx-auto mb-4" />
            <h1 className="font-display text-2xl font-bold">Check your email</h1>
            <p className="text-zinc-500 mt-2">If an account exists for {email}, we've sent a reset link. (Check the backend logs in this demo.)</p>
            <Link to="/login"><Button variant="outline" className="mt-6 h-12 w-full border-zinc-300">Back to sign in</Button></Link>
          </div>
        ) : (
          <>
            <h1 className="font-display text-3xl font-bold tracking-tight">Reset password</h1>
            <p className="text-zinc-500 mt-1 mb-8">Enter your email and we'll send you a reset link.</p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label className="text-sm font-semibold">Email</Label>
                <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="h-12 mt-1.5 focus:ring-2 focus:ring-emerald-500" data-testid="forgot-email" />
              </div>
              {error && <p className="text-sm text-red-600">{error}</p>}
              <Button type="submit" disabled={loading} className="w-full h-12 bg-emerald-500 hover:bg-emerald-600 text-white font-semibold" data-testid="forgot-submit">
                {loading ? <Spinner size={20} className="animate-spin" /> : "Send reset link"}
              </Button>
            </form>
            <p className="mt-6 text-sm text-zinc-500 text-center"><Link to="/login" className="text-emerald-600 font-semibold">Back to sign in</Link></p>
          </>
        )}
      </div>
    </div>
  );
}
